import { type FC } from 'react';
import Pagination from '3-components/Pagination/Pagination';

export interface ListingPaginationState {
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
}

export interface ListingPaginationProps extends ListingPaginationState {
    totalItems: number;
    itemsPerPage: number;
}

const ListingPagination: FC<ListingPaginationProps> = ({ totalItems, itemsPerPage, page, setPage }) => {
    const pageNum = Math.ceil(totalItems / itemsPerPage);

    return (
        <div className="listing-app-pagination">
            <Pagination
                selectedPage={page}
                pageNum={pageNum}
                onChange={(selectedPage): void => {
                    setPage(selectedPage);
                }}
            />
        </div>
    );
};

export default ListingPagination;
